/**
 * Shuffles list of items
 */
export const shuffleItems = <T>(list: T[]): T[] => {
  return list.toSorted(() => Math.random() - 0.5);
};
